import { Component, Prop, h } from '@stencil/core';
import { Loading, Leaf } from '../../icons/index';

@Component({
  tag: 'ugc-loading',
  styleUrl: 'ugc-loading.scss',
  shadow: false,
})
export class UgcLoading {
  @Prop() wraperStyle = {};
  render() {
    return (
      <div class="loading-wrap flex-row-center-center" style={this.wraperStyle}>
        <div class="loading-content flex-row-center-center">
          <Loading width="24" height="24" />
          <Leaf width="48" height="48" />
        </div>
      </div>
    );
  }
}
